<template>
  <v-card>
    <v-card-title class="justify-center">
      <span class="text-h5">{{ $t('Contractor Management') }}</span>
    </v-card-title>
    <v-card-text>
  <v-container
    id="user-profile-view"
    fluid
    tag="section"
  >

    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="primary"
          icon="mdi-pickaxe"
        >
          <template #title> {{ $t('Contractor Information') }} </template>

          <v-form>
            <v-container class="py-0">
              <v-row>

                <v-col cols="12" md="6" >
                  <v-select
                    v-if="form_type=='editForm' && phaseType=='planning'"
                    :items="contractorList"
                    :item-value="item=>item.id"
                    :item-text="item=>item.name"
                    :label="$t('Contractor')"
                    v-model="vfm.contractor_id"
                  ></v-select>
                 <div v-if="form_type=='viewForm' && phaseType=='all'">
                   <p>{{ $t('Contractor')}}</p>
                 </div>
                </v-col>
               
                <v-col cols="12" md="6" style="margin: auto;" v-if="form_type=='editForm' && phaseType=='planning'" >
                  <input type="checkbox" id="contractor" name="contractor" v-model="newContractorValue" />
                  <label id="contractor_label" for="contractor">{{$t('New Contractor')}}</label>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: 30px;" v-if="vfm.contractor_id !== null">

                <div v-if="form_type=='viewForm'">
                  <v-col cols="12">{{$t('Contractor Name')}}: <span class="font-weight-medium">{{ vfm.contractor.name }}</span></v-col>
                  <v-col cols="12">{{$t('Primary Contact and Position')}}: <span class="font-weight-medium">{{ vfm.contractor.contact }}, {{ vfm.contractor.position }}</span></v-col>
                  <v-col cols="12">{{$t('Contractor Address')}}: <span class="font-weight-medium">{{ vfm.contractor.address }}</span></v-col>
                  <v-col cols="12">{{$t('Province')}}: <span class="font-weight-medium">{{ vfm.contractor.province.translation.name }}</span></v-col>
                  <v-col cols="12">{{$t('Phone Number')}}: <span class="font-weight-medium">{{ vfm.contractor.phone_number }}</span></v-col>
                  <v-col cols="12">{{$t('Experience - Demonstrated experience of successfully completing projects of similar size and scope in Lao PDR')}}: <span class="font-weight-medium">{{ getTranslation(vfm.contractor.contractor_experience.translation.name) }}</span></v-col>
                  <v-col cols="12">{{$t('Number of Project < 20 bLAK')}}: <span class="font-weight-medium">{{ vfm.contractor.number_project_under_20 }} {{$t('Projects')}}</span></v-col>
                  <v-col cols="12">{{$t('Number of Project > 20 bLAK')}}: <span class="font-weight-medium">{{ vfm.contractor.number_project_above_20 }} {{$t('Projects')}}</span></v-col> 
                </div>      

                <div v-if="form_type=='editForm'">
                  <v-row>
                    <v-col cols="12" md="3" >
                      <v-text-field
                        color="purple"
                        :label="$t('Contractor Name')" 
                        v-model="oldContractor.name"
                        :hint="$t('Mandatory')"
                        :rules="nameRules"
                        persistent-hint
                      />
                     
                    </v-col>
                    <v-col cols="12" md="3" >
                      <v-text-field
                        color="purple"
                        :label="$t('Primary Contact and Position')"
                        v-model="oldContractor.contact"
                      />
                      
                    </v-col>
                    <v-col cols="12" md="3" >
                      <v-text-field
                        color="purple"
                        :label="$t('Contractor Address')"
                        v-model="oldContractor.address"
                      />
                    
                    </v-col>

                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-select
                        v-model="oldContractor.province_id"
                        :items="provinceList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        :label="$t('Province')"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                        <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.translation.name) }}</div>
                        </template>
                      </v-select>
                    </v-col>

                    <v-col cols="12" md="3" >
                      <v-text-field
                        color="purple"
                        :label="$t('Phone Number')"
                        v-model="oldContractor.phone_number"
                      />
                    
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" >
                      <v-select
                          :items="contractorExperienceList"
                          :item-value="item=>item.id"
                          :item-text="item=>item.translation.name"
                          v-model="oldContractor.contractor_experience_id"
                          :label="$t('Experience - Demonstrated experience of successfully completing projects of similar size and scope in Lao PDR')"
                          :hint="$t('Mandatory')"
                          :rules="selectRules"
                          persistent-hint
                      ></v-select> 
                    </v-col>
                  </v-row>
                  <v-row >
                    <v-col cols="12" >
                      {{ $t('Project Commitment - Total number and value of all current project commitments in Lao PDR') }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        color="purple"
                        type="number"
                        :label="$t('Number of Project < 20 bLAK')"
                        v-model="oldContractor.number_project_under_20"
                        :hint="$t('Positive Number is required')"
                        :rules="numberRules"
                        persistent-hint
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        color="purple"
                        type="number"
                        :label="$t('Number of Project > 20 bLAK')"
                        v-model="oldContractor.number_project_above_20"
                        :hint="$t('Positive Number is required')"
                        :rules="numberRules"
                        persistent-hint
                      />
                    </v-col>
                  </v-row>
              
                </div>

              </v-row>

              <v-row style="margin-bottom: 30px;" v-if="vfm.contractor_id === null && !newContractorFlag"> {{ $t('No Contractor') }}</v-row>
         
              <div v-if="newContractorFlag && phaseType=='planning'">
                <v-row> 
                    <v-col cols="12" md="3" >
                    {{ $t('New Contractor Information') }}:
                     </v-col> 
                </v-row>
                <v-row>
                  <v-col cols="12" md="3" >
                    <v-text-field
                      color="purple"
                      :label="$t('Contractor Name')" 
                      v-model="newContractor.name"
                      :hint="$t('Mandatory')"
                      :rules="nameRules"
                      persistent-hint
                    />
                   
                  </v-col>
                  <v-col cols="12" md="3" >
                    <v-text-field
                      color="purple"
                      :label="$t('Primary Contact and Position')"
                      v-model="newContractor.contact"
                    />
                    
                  </v-col>
                  <v-col cols="12" md="3" >
                    <v-text-field
                      color="purple"
                      :label="$t('Contractor Address')"
                      v-model="newContractor.address"
                    />
                  
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-select
                      v-model="newContractor.province_id"
                      :items="provinceList"
                      :item-value="item=>item.id"
                      :item-text="item=>item.translation.name"
                      :label="$t('Province')"
                      :hint="$t('Mandatory')"
                      :rules="selectRules"
                      persistent-hint
                    >
                      <template v-slot:item="{ item }">
                        <div>{{ getTranslation(item.translation.name) }}</div>
                      </template>
                    </v-select>
                  </v-col>

                  <v-col cols="12" md="3" >
                    <v-text-field
                      color="purple"
                      :label="$t('Phone Number')"
                      v-model="newContractor.phone_number"
                    />
                  
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" >
                    <v-select
                        :items="contractorExperienceList"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        v-model="newContractor.contractor_experience_id"
                        :label="$t('Experience - Demonstrated experience of successfully completing projects of similar size and scope in Lao PDR')"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                    ></v-select> 
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12" >
                    {{ $t('Project Commitment - Total number and value of all current project commitments in Lao PDR') }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      color="purple"
                      type="number"
                      :label="$t('Number of Project < 20 bLAK')"
                      v-model="newContractor.number_project_under_20"
                      :hint="$t('Positive Number is required')"
                      :rules="numberRules"
                      persistent-hint
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      color="purple"
                      type="number"
                      :label="$t('Number of Project > 20 bLAK')"
                      v-model="newContractor.number_project_above_20"
                      :hint="$t('Positive Number is required')"
                      :rules="numberRules"
                      persistent-hint
                    />
                  </v-col>
                </v-row>
                <!--<v-row>
                    <v-col cols="12" md="3">
                      <v-file-input multiple :label="$t('Insert Contractor Document')" v-model="newContractor.documents"></v-file-input>
                  </v-col>
                </v-row>-->
              </div>

            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>





    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="primary"
          icon="mdi-currency-usd"
        >
          <template #title> {{ $t('Contractor Documents') }} </template>

          <v-form>
            <v-container class="py-0">

                <v-row v-if="form_type=='viewForm' ">
                  <v-data-table style="margin:auto;"
                    class="v-data-table"
                    :headers="documentHeaders"
                    :items="contractor_document" 
                  >
                    <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                      <span>{{ getHeader(header.text) }}</span>
                    </template>
                    <template v-slot:item.document="{ item }">
                      <span
                        text class="align-items--right"
                        min-width="200px"
                      > 
                          <span class="font-weight-black"> {{ getTranslation(item.name) }} </span> : <span class="hyperlink_document" v-on:click="download(item.original_name, project.id, null)">{{ item.original_name }}</span>
                      </span>
                    </template>
                    <template v-slot:item.updatetime="{ item }">
                      <span
                        text class="align-items--right"
                        min-width="200px"
                        v-if="item.updatedAt"
                      > 
                          {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                      </span>
                    </template>
                    <template v-slot:item.missing_document="{ item }">
                        <span
                          text class="align-items--right"
                          min-width="200px"
                        >
                            <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                        </span>
                      </template>

                  </v-data-table>
                </v-row>

               <v-row v-if="form_type=='editForm' "> 
                    <v-data-table style="margin:auto;"
                      class="v-data-table-document"
                      :headers="documentHeaders"
                      :items="contractor_document" 
                    >

                      <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                        <span>{{ getHeader(header.text) }}</span>
                      </template>
                      <template v-slot:item.document="{ item }">
                        <v-file-input
                          :label="item.name"
                          v-model="contractorDocumentList[item.id-1]"
                        >
                        <template slot="append">{{ contractor_document[item.id-1].original_name }}</template>
                        </v-file-input>
                      </template>
                      <template v-slot:item.updatetime="{ item }">
                        <span
                          text class="align-items--right"
                          min-width="200px"
                          v-if="item.updatedAt"
                        > 
                            {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                        </span>
                      </template>
                      <template v-slot:item.missing_document="{ item }">
                          <span
                            text class="align-items--right"
                            min-width="200px"
                          >
                              <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                          </span>
                        </template>
                    </v-data-table>
                  </v-row> 

              <!--
              <v-row><span style="margin: auto;">{{ $t('Rapid rebuilding of people\'s livelihoods') }}</span></v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="formType=='addForm' && phaseType=='planning'"
                    :label="$t('Number of directly affected villages that the asset services:')"
                    v-model="vfm.village_beneficiary_asset_vfm_number"
                    disabled
                  />
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                    <h3 class="font-weight-regular">{{ $t('Number of directly affected villages that the asset services:')}} {{ vfm.village_beneficiary_asset_vfm_number }}</h3>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="formType=='addForm' && phaseType=='planning'"
                    :label="$t('Number of directly affected people that the asset services:')"
                    v-model="vfm.people_beneficiary_asset_vfm_number"
                    disabled
                  />
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                    <h3 class="font-weight-regular">{{ $t('Number of directly affected people that the asset services:')}} {{ vfm.people_beneficiary_asset_vfm_number }}</h3>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="formType=='addForm' && phaseType=='planning'"
                    :label="$t('% of people in the district living below the poverty line:')"
                    v-model="vfm.people_poverty_vfm_percent"
                    disabled
                  />
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                    <h3 class="font-weight-regular">{{ $t('% of people in the district living below the poverty line:')}} {{ vfm.people_poverty_vfm_percent }}</h3>
                  </div>
                </v-col>
              </v-row>

              <v-row><span style="margin: auto;">{{ $t('Local industry & community participation') }}</span></v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="formType=='addForm' && phaseType=='planning'"
                    :label="$t('Number of directly affected villages consulted')"
                    v-model="vfm.affected_village_consulted_vfm_number"
                  />
                    <div v-if="formType=='viewForm' && phaseType=='all'">
                  <h3 class="font-weight-regular">{{ $t('Number of directly affected villages consulted')}}: {{ vfm.affected_village_consulted_vfm_number }}</h3>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="phaseType=='planning'"
                    :label="$t('Number of directly affected people consulted')"
                    v-model="vfm.affected_people_consulted_vfm_number"
                  />
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                  <h3 class="font-weight-regular">{{ $t('Number of directly affected people consulted')}}: {{ vfm.affected_people_consulted_vfm_number }}</h3>
                  </div>
                </v-col>
              </v-row>              
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="phaseType=='planning'"
                    :label="$t('Number of directly affected women consulted')"
                    v-model="vfm.affected_woman_consulted_vfm_number"
                  />
                   <div v-if="formType=='viewForm' && phaseType=='all'">
                  <h3 class="font-weight-regular">{{ $t('Number of directly affected women consulted')}}: {{ vfm.affected_woman_consulted_vfm_number }}</h3>
                  </div>
                </v-col>
              </v-row>              
              <v-row>
                <v-col cols="12" md="12" >
                  <span> {{ $t('Local registered contractor (ie ... with head office location in Province)') }}</span>
                  <v-radio-group inline v-if="formType=='addForm' && phaseType=='planning'" v-model="vfm.registered_local_contractor_vfm">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                      <p class="font-weight-regular">
                        <span v-if="vfm.registered_local_contractor_vfm">{{$t('Yes')}}</span>
                        <span v-else>{{$t('No')}}</span>
                      </p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="formType=='addForm' && phaseType=='planning'"
                    :label="$t('Number of local full-time staff')"
                    v-model="vfm.full_staff_number_vfm"
                  />
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                  <h3 class="font-weight-regular">{{ $t('Number of local full-time staff')}}: {{ vfm.full_staff_number_vfm }}</h3>
                  </div>
                </v-col>
              </v-row>              
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="formType=='addForm' && phaseType=='planning'"
                    :label="$t('Number of local full-time women staff')"
                    v-model="vfm.woman_full_staff_number_vfm"
                  />
                    <div v-if="formType=='viewForm' && phaseType=='all'">
                  <h3 class="font-weight-regular">{{ $t('Number of local full-time women staff')}}: {{ vfm.woman_full_staff_number_vfm }}</h3>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="formType=='addForm' && phaseType=='planning'"
                    :label="$t('Number of locally hired temporary labour-days')"
                    v-model="vfm.temporary_staff_number_day_vfm"
                  />
                    <div v-if="formType=='viewForm' && phaseType=='all'">
                  <h3 class="font-weight-regular">{{ $t('Number of locally hired temporary labour-days')}}: {{ vfm.temporary_staff_number_day_vfm }}</h3>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="formType=='addForm' && phaseType=='planning'"
                    :label="$t('Number of locally hired temporary labour-days (women)')"
                    v-model="vfm.temporary_staff_women_percent_vfm"
                  />
                    <div v-if="formType=='viewForm' && phaseType=='all'">
                  <h3 class="font-weight-regular">{{ $t('Number of locally hired temporary labour-days (women)')}}: {{ vfm.temporary_staff_women_percent_vfm }}</h3>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12" >
                  <span> {{ $t('Will the majority of material be locally sourced') }}</span>
                  <v-radio-group inline v-if="formType=='addForm' && phaseType=='planning'" v-model="vfm.majority_local_material_vfm">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                      <p class="font-weight-regular">
                        <span v-if="vfm.majority_local_material_vfm">{{$t('Yes')}}</span>
                        <span v-else>{{$t('No')}}</span>
                      </p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <span> {{ $t('Will the majority of machinery be locally sourced') }}</span>
                  <v-radio-group inline v-if="formType=='addForm' && phaseType=='planning'" v-model="vfm.majority_local_machinery_vfm">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                     
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                      <p class="font-weight-regular">
                        <span v-if="vfm.majority_local_machinery_vfm">{{$t('Yes')}}</span>
                        <span v-else>{{$t('No')}}</span>
                      </p>
                  </div>
             
                </v-col>
              </v-row>

              <v-row><span style="margin: auto;">{{ $t('Design Quality & Development Gains') }}</span></v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <span> {{ $t('Has the asset been maintained to a service level in the past 12 months ?') }}</span>
                  <v-radio-group inline v-if="formType=='addForm' && phaseType=='planning'" v-model="vfm.serviceable_level_maintained_vfm">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                     
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                      <p class="font-weight-regular">
                        <span v-if="vfm.serviceable_level_maintained_vfm">{{$t('Yes')}}</span>
                        <span v-else>{{$t('No')}}</span>
                      </p>
                  </div>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12" md="12" >
                  <span>{{ $t('Has natural hazard risk assessment been completed ?') }}</span>
                  <v-radio-group inline v-if="formType=='addForm' && phaseType=='planning'" v-model="vfm.environmental_risk_assessment_completed_vfm">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                   
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                      <p class="font-weight-regular">
                        <span v-if="vfm.environmental_risk_assessment_completed_vfm">{{$t('Yes')}}</span>
                        <span v-else>{{$t('No')}}</span>
                      </p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <span>{{ $t('Has environmental social and safeguard process been completed ?') }}</span>
                  <v-radio-group inline v-if="formType=='addForm' && phaseType=='planning'" v-model="vfm.grievance_established_vfm">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                  
                  <div v-if="formType=='viewForm' && phaseType=='all'">
                      <p class="font-weight-regular">
                        <span v-if="vfm.grievance_established_vfm">{{$t('Yes')}}</span>
                        <span v-else>{{$t('No')}}</span>
                      </p>
                  </div>

                </v-col>
              </v-row>
            -->
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="primary"
          icon="mdi-currency-usd"
        >
          <template #title> {{ $t('Contractor Project Documents') }} </template>

          <v-form>
            <v-container class="py-0">

               <v-row v-if="form_type=='viewForm' ">
                  <v-data-table style="margin:auto;"
                    class="v-data-table"
                    :headers="documentHeaders"
                    :items="contractor_project_document" 
                  >
                    <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                      <span>{{ getHeader(header.text) }}</span>
                    </template>
                    <template v-slot:item.document="{ item }">
                      <span
                        text class="align-items--right"
                        min-width="200px"
                      > 
                          <span class="font-weight-black"> {{ getTranslation(item.name) }} </span> : <span class="hyperlink_document" v-on:click="download(item.original_name, project.id, null)">{{ item.original_name }}</span>
                      </span>
                    </template>
                    <template v-slot:item.updatetime="{ item }">
                      <span
                        text class="align-items--right"
                        min-width="200px"
                        v-if="item.updatedAt"
                      > 
                          {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                      </span>
                    </template>
                    <template v-slot:item.missing_document="{ item }">
                        <span
                          text class="align-items--right"
                          min-width="200px"
                        >
                            <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                        </span>
                      </template>

                  </v-data-table>
                </v-row>

               <v-row v-if="form_type=='editForm' "> 
                    <v-data-table style="margin:auto;"
                      class="v-data-table-document"
                      :headers="documentHeaders"
                      :items="contractor_project_document" 
                    >

                      <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                        <span>{{ getHeader(header.text) }}</span>
                      </template>
                      <template v-slot:item.document="{ item }">
                        <v-file-input
                          :label="item.name"
                          v-model="contractorProjectDocumentList[item.id-1]"
                        >
                        <template slot="append">{{ contractor_project_document[item.id-1].original_name }}</template>
                        </v-file-input>
                      </template>
                      <template v-slot:item.updatetime="{ item }">
                        <span
                          text class="align-items--right"
                          min-width="200px"
                          v-if="item.updatedAt"
                        > 
                            {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                        </span>
                      </template>
                      <template v-slot:item.missing_document="{ item }">
                          <span
                            text class="align-items--right"
                            min-width="200px"
                          >
                              <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                          </span>
                        </template>
                    </v-data-table>
                  </v-row> 
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
    </v-card-text>
    <v-card-actions v-if="form_type == 'viewForm'">
      <v-spacer></v-spacer>
      <v-btn
        class="close-button-fixed close-button"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn class="update-button-fixed small" color="success" 
             v-on:click="update(vfm)" 
             v-if="(phaseType !=='all') && 
             ($store.state.auth.user.user_functions[6].user_type_id !== 1)">
        <v-icon>mdi-update</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="form_type == 'addForm' || form_type == 'editForm'">
      <v-spacer></v-spacer>
      <v-btn
        class="close-vfm-button-fixed close-button"
        text
        v-on:click="close_edit()"
      >
        {{ $t('Close') }}
        <v-dialog v-model="dialog_modal_message" persistent max-width="800px" :retain-focus="false">
          <MessageAlert 
              v-if="dialog_modal_message" 
              :messageProps="$store.state.messages.close" 
              :cancelProps="$store.state.messages.no" 
              :validationProps="$store.state.messages.yes" 
              :dialog.sync="dialog_modal_message" 
              @answerModal="getModalAnswer"
          />
        </v-dialog>
      </v-btn>
      <v-btn
        class="save-vfm-button-fixed"
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save()"
        v-if="(vfm.contractor_id 
              || (newContractorFlag && newContractor.contractor_experience_id && newContractor.province_id && (newContractor.name && newContractor.name !== null && newContractor.name !== '')
              )
              ) && $store.state.auth.user.user_functions[6].user_type_id !== 1"
      >
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'ValueForMoneyForm',
    props: {
      vfm: {
        type: Object
      },
      formType: {
        type: String
      },
      phaseType: {
        type: String
      }
    },
    
    data: () => ({
      dialog_modal_message: false,
      form_type: '',
      newContractorValue: false,
      newContractorFlag: false,
      newContractor: {},
      contractor_document: [],
      contractorDocumentList:[],
      contractor_project_document: [],
      contractorProjectDocumentList:[],
      documentHeaders: [
        {
          sortable: false,
          text: 'Document',
          align: 'center',
          value: 'document',
          width: '500px'
        },
        {
          sortable: false,
          text: 'Last Update',
          align: 'center',
          value: 'updatetime',
        },
        {
          sortable: false,
          text: 'Missing Document',
          align: 'center',
          value: 'missing_document',
        }
      ]
    }),
    computed: {
        contractorList() {
          return this.$store.state.projects.contractorList;
        }, 
        contractorExperienceList() {
          return this.$store.state.referentials.contractorExperienceList;
        },
        contractorDocuments() {
          return this.$store.state.projects.contractorDocuments;
        },
        contractorProjectDocuments() {
          return this.$store.state.projects.contractorProjectDocuments;
        },
        provinceList() {
          return this.$store.state.referentials.provinceList;
        }
    },
    created: function(){
      //https://v15.vuetifyjs.com/en/components/forms/ 
      this.nameRules = [ v => !!v || this.getTranslation('Name is required') ];
      this.numberRules = [ v => v > 0 || this.getTranslation('Positive Number is required') ];
      this.selectRules = [ v => !!v || this.getTranslation('At least 1 Information is required') ];
    },
    mounted: function(){

      this.form_type = this._props.formType;

      //NOT USED ANYMORE
      //this.$store.dispatch('projects/getContractorDocuments',{project_id: this.vfm.id});
      //this.$store.dispatch('projects/getContractorProjectDocuments',{project_id: this.vfm.id});

      this.$store.dispatch('referentials/getProvinceList');
      this.$store.dispatch('referentials/getContractorExperienceList');


      //console.log('doc', this.$store.state.referentials.contractorDocumentReferentialList);

      for(var i=0; i < this.vfm.contractor_documents.length; i++){
        this.contractorDocumentList.push(this.$store.state.referentials.contractorDocumentReferentialList[i])
        this.contractor_document.push({
            id: i+1,
            name: this.contractorDocumentList[i].translation.name,
            original_name: this.vfm.contractor_documents[i].original_name,
            updatedAt: this.vfm.contractor_documents[i].updatedAt
          });
      }

      for(var i=0; i < this.vfm.contractor_project_documents.length; i++){
        this.contractorProjectDocumentList.push(this.$store.state.referentials.contractorDocumentReferentialList[i+3]);
        this.contractor_project_document.push({
            id: i+1,
            name: this.contractorProjectDocumentList[i].translation.name,
            original_name: this.vfm.contractor_project_documents[i].original_name,
            updatedAt: this.vfm.contractor_project_documents[i].updatedAt
          });
      }

    },
    destroyed(){
      this.newContractorFlag = false;
      this.newContractor = {};
      this.$store.dispatch('projects/getContractorList');
      this.$store.dispatch('projects/getProjectContractorList');
    },
    watch: {
      /*contractorDocuments: function(value){
        console.log('****WATCH contractorDocuments ', value);
      },
      contractorProjectDocuments: function(value){
        console.log('****WATCH contractorProjectDocuments ', value);
      },*/
      newContractorValue: function (){ 
        if(this.newContractorValue){
            this.vfm.contractor_id = null;
            this.newContractorFlag = true;
        }else{
          this.newContractorFlag = false;
        }
      },
      'vfm.contractor_id': function(){
          this.vfm.contractor = this.contractorList.filter(o => o.id === this.vfm.contractor_id)[0];
          if(this.vfm.contractor && this.vfm.contractor.id){
            this.newContractorValue = false;
            this.vfm.contractor_id = this.vfm.contractor.id;
            this.oldContractor = this.vfm.contractor;
            //this.$store.state.projects.contractorDocumentList = this.vfm.contractor.contractor_documents;
          }else{
            this.newContractorValue = true;
            this.vfm.contractor_id = null;
          }
      }
    },
   
    methods: {
      getHeader(val) {
        return this.$t(val);
      },
      getTranslation(val) {
        return this.$t(val);
      },
      close: function(){
        this.newContractorFlag = false;
        this.$emit('update:dialog', false)
      },
      close_edit: function(){
        this.dialog_modal_message = true;
      },
      getModalAnswer(value){
        if(value){
          this.newContractorFlag = false;
          this.$emit('update:dialog', false);
        }
      },
      update: function(vfm){

        this.form_type = 'editForm';
        console.log('vfm', vfm);
        this.vfm = vfm;

        this.oldContractor = this.vfm.contractor;
      },
      download:function(doc, project_id, project_reporting_id){

        var document_information = {
          original_name: doc
        }
        this.$store.dispatch('projects/downloadContractorDocument', document_information);

      },
      save: function(){

          if(this.newContractorFlag){
            this.vfm.new_contractor = this.newContractor;
          }else{
            this.vfm.old_contractor = this.oldContractor;
          }

          //console.log('this.vfm', this.vfm);

          this.$store.dispatch('projects/addOrUpdateContractor',this.vfm);
          this.$store.dispatch('projects/getContractorList');
          this.newContractorFlag = false;

        //DOCUMENT MANAGEMENT
        let form = new FormData();
        this.vfm.contractor_documents = this.vfm.contractor_documents.map( (data, index) => ({...data, toUpdate:false}) );
        this.vfm.contractor_doc = [];
        for(var i=0; i < this.contractorDocumentList.length; i++){
          if(this.contractorDocumentList[i].name){
            this.vfm.contractor_doc.push(this.contractorDocumentList[i]);
            this.vfm.contractor_documents[i].original_name = this.contractorDocumentList[i].name;
            this.vfm.contractor_documents[i].toUpdate = true;
            form.append("file", this.vfm.contractor_doc[i]);
          }
        }
        this.vfm.contractor_project_documents = this.vfm.contractor_project_documents.map( (data, index) => ({...data, toUpdate:false}) );
        this.vfm.contractor_project_doc = [];
        for(var j=0; j < this.contractorProjectDocumentList.length; j++){
          if(this.contractorProjectDocumentList[j].name){
            this.vfm.contractor_project_doc.push(this.contractorProjectDocumentList[j]);
            this.vfm.contractor_project_documents[j].original_name = this.contractorProjectDocumentList[j].name;
            this.vfm.contractor_project_documents[j].toUpdate = true;
            form.append("file", this.vfm.contractor_project_doc[j]);
          }
        }
        this.$store.dispatch('projects/updateContractorDocument',this.vfm);

        this.$emit('update:dialog', false)
      },
     
    }
  }
</script>
<style>
  .row + .row {
    margin-top: 0px;
  }
  .col-md-12, .col-md-3, .col-12 {
    padding: 2px 10px 2px 10px;
  }
  .v-input--selection-controls {
    margin-top: 2px; 
    padding-top: 2px;
  }
  v-btn {
    padding: 2px;
  }
  .v-picker {
    width: 210px;
    height: 300px;
  }
  .v-date-picker-header{
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .v-date-picker-header__value div {
    width: 100%;
  }
  .v-picker__title {
    padding: 7px;
  }
  .v-date-picker-title {
    align-items: center;
  }
  .v-date-picker-table--date th {
    padding: 0px;
  }
  .v-date-picker-table th {
    font-size: 10px;
  }
  .v-picker__body  {
    width: 150px;
    height: 100px;
  }
  div.v-picker__body, div.v-picker-header {
    width: 210px;
  }
  .v-picker__body > div {
      position: relative;
      right: 43px;
      width: 70%;
  }
  .v-picker__title__btn {
    font-size: 10px;
  }
  .v-date-picker-header__value {
    font-size: 10px;
    width: 150px;
  }
  .v-date-picker-table {
    width: 210px;
    padding: 0px;
    height: 100px;
  }
  .v-btn--icon.v-size--default {
    height: 30px;
    width: 30px;
}
.v-btn--icon.v-size--default .v-icon {
    height: 15px;
    font-size: 15px;
    width: 15px;
}
.v-date-picker-table--date .v-btn {
    height: 20px;
    width: 20px;
}
.v-date-picker-table .v-btn {
  font-size: 10px;
}
#contractor_label {
  margin-left: 5px;
}
.hyperlink_document {
  cursor:pointer;
  text-decoration: underline;
}
.close-vfm-button-fixed {
    position: fixed;
    right: 195px;
    bottom: 53px;
}
.save-vfm-button-fixed {
    position: fixed;
    right: 115px;
    bottom: 53px;
}
.update-vfm-button-fixed {
    position: fixed;
    right: 115px;
    bottom: 53px;
}

</style>
